import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MapLoadError = () => ___EmotionJSX("div", null, "Error loading maps. Please try again later.");
export default MapLoadError;